import * as React from 'react';
import Box from '@mui/material/Box';
import TreeView from '@mui/lab/TreeView';
import TreeItem from '@mui/lab/TreeItem';
import {FaChevronDown, FaChevronRight} from "react-icons/fa";
import {useNavigate} from "react-router-dom";
import {PencilSquareIcon, PlusIcon, TrashIcon} from "@heroicons/react/20/solid";
import {useTranslation} from "react-i18next";
import {GiExpand} from "react-icons/gi";
import {BiCollapse} from "react-icons/bi";
import {deleteItem, getList} from "../../services/service";
import {useSelector} from "react-redux";
import {useEffect} from "react";
import ModalAddProfileSystem from "../../components/profileSystem/ModalAddProfileSystem";
import "../../components/profileSystem/treeSelect.css"
import swal from "sweetalert";
import {toast} from "react-toastify";

var collect_tree_selected_Ids = [];

function makeChildren(children) {
    if (children.length > 0) {
        return children.map((item) => {
            collect_tree_selected_Ids.push(item.id.toString());
            return (
                <TreeItem
                    key={item.id.toString()}
                    nodeId={item.id.toString()}
                    label={item.name}
                >{item.children ? makeChildren(item.children) : null}
                </TreeItem>
            )
        });
    }
    return;
}

export default function ProfileSystemTreeTableComponent({selectedRowId, setSelectedRowId}) {
    const [expanded, setExpanded] = React.useState([]);
    const [selected, setSelected] = React.useState([]);
    const [selectedRow, setSelectedRow] = React.useState([]);
    const [treeData, setTreeData] = React.useState([]);
    const [open, setOpen] = React.useState(false);
    const [rowId, setRowId] = React.useState(null)

    const {t} = useTranslation();
    const navigate = useNavigate();
    const {token} = useSelector((state) => state.user);

    const handleToggle = (event, nodeIds) => {
        setExpanded(nodeIds);
    };

    const handleSelect = (event, nodeIds) => {
        collect_tree_selected_Ids.push(nodeIds);
        setSelectedRowId(nodeIds);
    };

    const handleExpandClick = () => {
        setExpanded((oldExpanded) =>
            oldExpanded.length === 0 ? collect_tree_selected_Ids : [],
        );
    };

    const handleEditClick = () => {
        setRowId(selectedRowId);
        setOpen(true);
    }

    const fetchData = async () => {
        const response = await getList(
            `${process.env.REACT_APP_HOST_BASE_URL}/v1/profile/system/list/tree`,
            token,
        );
        if (response.success) {
            let data_tree = response.data.map((item) => {
                collect_tree_selected_Ids.push(item.id.toString());
                return (
                    <TreeItem
                        key={item.id.toString()}
                        nodeId={item.id.toString()}
                        label={item.name}
                    >{item.children ? makeChildren(item.children) : null}
                    </TreeItem>
                )
            });
            setTreeData(data_tree);
        } else {
            navigate("/error", {
                state: {
                    status: response.status,
                    message: response.message ? response.message : null,
                },
            });
        }
    };

    useEffect(() => {
        fetchData();
        if (!open) {
            setRowId(null);
        }
    }, [open]);

    const onDeleteItem = async () => {
        const responseReceived = await swal({
            title: t(`action.delete_item.title`), text: t(`action.delete_item.text`), icon: "warning", buttons: {
                cancel: true, confirm: true,
            },
        });
        if (responseReceived) {
            const response = await deleteItem(`${process.env.REACT_APP_HOST_BASE_URL}/v1/profile/system/${selectedRowId}`, token);
            if (response.success) {
                fetchData();
                setSelectedRowId(null);
                toast.success(t('action.delete_success'), {
                    position: "bottom-right", autoClose: 3000, closeOnClick: true, className: "add-success"
                });
            } else {
                setSelectedRowId(null);
                if (response.status === 420) {
                    toast.warn(response.body.error, {
                        position: "bottom-right",
                        autoClose: 10000,
                        closeOnClick: true,
                        className: "product-background",
                        pauseOnHover: true,
                    });
                } else {
                    navigate("/error", {
                        state: {
                            status: response.status, message: response.body ? response.body.error : "Error",
                        },
                    });
                }
            }
        } else {
            return;
        }
    };

    return (
        <>
            <ModalAddProfileSystem
                open={open}
                setOpen={setOpen}
                fetchData={fetchData}
                rowId={rowId}
            />
            <div className="sm:flex-auto">
                <h1 className="text-xl font-semibold text-gray-900">
                    {t('table.system_profile')}
                </h1>
            </div>
            <Box sx={{height: 'auto', flexGrow: 1, maxWidth: 'auto', overflowY: 'auto', fontSize: 40}}>
                <div className="mb-10 mt-5 flex items-center ">
                    <div className="flex justify-between items-center">
                        <button
                            onClick={() => {
                                setOpen(true);
                            }}
                            type="button"
                            className="inline-flex bg-indigo-700 text-white active:bg-indigo-300 font-bold uppercase text-xs px-2 rounded-md py-2 shadow hover:shadow-md outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150">
                            <PlusIcon className="w-4 h-4 ml-1 "/>
                        </button>
                    </div>
                    <div className="flex justify-between items-center">
                        <button
                            onClick={handleEditClick}
                            type="button"
                            className={`${
                                selectedRowId
                                    ? "inline-flex bg-indigo-700 text-white active:bg-indigo-300 font-bold uppercase text-xs px-2 rounded-md py-2 shadow hover:shadow-md outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                                    : "inline-flex bg-indigo-200 text-white font-bold uppercase text-xs px-2 rounded-md py-2 shadow hover:bg-indigo-200 focus:outline-none focus:ring-2 focus:ring-indigo-200 focus:ring-offset-2 mr-1 mb-1 sm:col-start-2 sm:text-sm cursor-no-drop"
                            }`}
                            disabled={!selectedRowId}
                        >
                            <PencilSquareIcon className="w-4 h-4 ml-1"/>

                        </button>
                    </div>
                    <div className="flex justify-between items-center">
                        <button
                            onClick={onDeleteItem}
                            type="button"
                            className={`${
                                selectedRowId
                                    ? "inline-flex bg-indigo-700 text-white active:bg-indigo-300 font-bold uppercase text-xs px-2 rounded-md py-2 shadow hover:shadow-md outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                                    : "inline-flex bg-indigo-200 text-white font-bold uppercase text-xs px-2 rounded-md py-2 shadow hover:bg-indigo-200 focus:outline-none focus:ring-2 focus:ring-indigo-200 focus:ring-offset-2 mr-1 mb-1 sm:col-start-2 sm:text-sm cursor-no-drop"
                            }`}
                            disabled={!selectedRowId}
                        >
                            <TrashIcon className="w-4 h-4 ml-1 mr-1"/>

                        </button>
                    </div>
                    <div className="flex justify-between items-center ml-2">
                        <button
                            className="bg-blue-700 text-white active:bg-blue-400 font-bold uppercase text-xs px-4 rounded-md py-2 shadow hover:shadow-md outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                            type="button"
                            onClick={handleExpandClick}>
                            {expanded.length === 0 ? (<span className="flex justify-between items-center"><GiExpand
                                className="mr-2"/>{t('action.expand')}</span>) : (
                                <span className="flex justify-between items-center"><BiCollapse
                                    className="mr-2"/>{t('action.collapse')}</span>)}
                        </button>
                    </div>
                </div>
                <TreeView
                    aria-label="controlled"
                    defaultCollapseIcon={<FaChevronDown/>}
                    defaultExpandIcon={<FaChevronRight/>}
                    expanded={expanded}
                    selected={selectedRowId}
                    onNodeToggle={handleToggle}
                    onNodeSelect={handleSelect}
                >
                    {treeData}
                </TreeView>
            </Box>
        </>
    );
}
